// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#block[data-v-75c6bd3b]{position:absolute;top:0;left:0;width:280px;height:70px;box-sizing:padding-box;border:1px dashed transparent}#block.selected[data-v-75c6bd3b]{border-color:#000}", ""]);
// Exports
module.exports = exports;
